/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_Copy_FailedInputs */

const en_directory_submit_badge_copy_failed = /** @type {(inputs: Directory_Submit_Badge_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not copy badge code`)
};

const zh_directory_submit_badge_copy_failed = /** @type {(inputs: Directory_Submit_Badge_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法复制徽章代码`)
};

/**
* | output |
* | --- |
* | "Could not copy badge code" |
*
* @param {Directory_Submit_Badge_Copy_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_copy_failed = /** @type {((inputs?: Directory_Submit_Badge_Copy_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_Copy_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_copy_failed(inputs)
	return zh_directory_submit_badge_copy_failed(inputs)
});
export { directory_submit_badge_copy_failed as "directory.submit.badge_copy_failed" }